function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#DDDDDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#CCCCCB;stroke-miterlimit:10;}\r\n\t.st3{fill:#F0EFEF;}\r\n\t.st4{fill:#D2D2D1;stroke:#CCCCCB;stroke-miterlimit:10;}\r\n\t.st5{fill:#7292B7;}\r\n\t.st6{fill:#577089;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M32.01,8.19c-7.03,0-12.73,1-12.73,2.24v41.11c0,1.23,5.7,2.24,12.73,2.24c7.03,0,12.73-1,12.73-2.24V10.42 C44.74,9.19,39.04,8.19,32.01,8.19z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M20.05,48.93v2.27c0,1.02,5.35,1.84,11.95,1.84s11.95-0.83,11.95-1.84v-2.27H20.05z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("ellipse", {
  className: "st0",
  cx: 31.99,
  cy: 48.63,
  rx: 11.95,
  ry: 1.93
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M19.26,51.53c0,1.23,6.54,2.24,13.27,2.24s12.18-1,12.18-2.24"
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  className: "st2",
  x1: 19.26,
  y1: 10.42,
  x2: 19.26,
  y2: 51.53
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  className: "st2",
  x1: 44.72,
  y1: 10.42,
  x2: 44.72,
  y2: 51.53
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M31.99,9.62c-6.6,0-11.95,0.87-11.95,1.94v35.75c0,1.07,5.35,1.94,11.95,1.94s11.95-0.87,11.95-1.94V11.57 C43.94,10.49,38.59,9.62,31.99,9.62z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  className: "st4",
  cx: 31.99,
  cy: 10.52,
  rx: 12.73,
  ry: 2.34
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "woda"
}, React.createElement("path", {
  id: "woda_d\\xF3\\u0142",
  className: "st5",
  d: "M43.92,27.62c0-1.26-5.34-2.28-11.94-2.28s-11.94,1.02-11.94,2.28v19.78h0.02 c0,1.26,5.34,2.28,11.94,2.28s11.94-1.02,11.94-2.28V27.62H43.92z"
}), React.createElement("ellipse", {
  id: "woda_g\\xF3ra",
  className: "st6",
  cx: 31.99,
  cy: 27.62,
  rx: 11.94,
  ry: 2.28
}));

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M21.88,25.44c0.51,0.36,1.21,0.81,2.01,1.14c0.18,0.07,0.3,0.24,0.32,0.42l2.02,20.13 c0.03,0.33-0.25,0.6-0.58,0.56c-0.44-0.06-1.19-0.21-2.43-0.58c-0.9-0.27-1.69-0.68-2.09-0.9c-0.17-0.09-0.27-0.27-0.26-0.46 l0.2-19.92C21.07,25.44,21.54,25.2,21.88,25.44z"
});

var SvgGlass = function SvgGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glass.4a30f732.svg";
export { ForwardRef as ReactComponent };